import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Clock, ArrowUpRight } from "lucide-react";
import { api, euro } from "@/lib/api";

export default function Services() {
  const [cats, setCats] = useState([]);
  const [services, setServices] = useState([]);
  const [params, setParams] = useSearchParams();
  const active = params.get("famiglia") || "all";

  useEffect(() => {
    api.get("/service-categories").then((r) => setCats(r.data)).catch(() => {});
    api.get("/services").then((r) => setServices(r.data)).catch(() => {});
  }, []);

  const filtered = active === "all" ? services : services.filter((s) => s.category_id === active);

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
      <span className="kima-overline text-burgundy">Il menù KIMA</span>
      <h1 className="font-serif text-5xl md:text-6xl text-espresso mt-3 mb-10">Servizi</h1>
      <div className="flex flex-wrap gap-3 mb-12">
        <button onClick={() => setParams({})} data-testid="filter-all" className={`px-5 py-2 rounded-sm text-sm border transition-colors ${active === "all" ? "bg-espresso text-ivory border-espresso" : "border-espresso/20 text-espresso hover:border-espresso"}`}>Tutti</button>
        {cats.map((c) => (
          <button key={c.id} onClick={() => setParams({ famiglia: c.id })} data-testid={`filter-${c.id}`} className={`px-5 py-2 rounded-sm text-sm border transition-colors ${active === c.id ? "bg-espresso text-ivory border-espresso" : "border-espresso/20 text-espresso hover:border-espresso"}`}>{c.name}</button>
        ))}
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {filtered.map((s) => (
          <div key={s.id} className="border border-espresso/10 bg-offwhite rounded-sm overflow-hidden flex flex-col">
            <div className="hover-zoom"><img src={s.image} alt={s.name} className="w-full aspect-[4/3] object-cover" /></div>
            <div className="p-6 flex flex-col flex-1">
              <h3 className="font-serif text-2xl text-espresso mb-2">{s.name}</h3>
              <p className="text-sm text-espresso/60 leading-relaxed flex-1">{s.description}</p>
              <div className="flex items-center gap-4 mt-5 text-sm text-espresso/70">
                <span className="flex items-center gap-1"><Clock size={15} /> {s.duration_min} min</span>
                <span className="font-medium text-espresso">{s.from_price ? "a partire da " : ""}{euro(s.base_price)}</span>
              </div>
              <Link to={`/prenota?service=${s.id}`} data-testid={`book-service-${s.id}`} className="mt-5 flex items-center justify-center gap-1 bg-espresso text-ivory py-3 rounded-sm hover:bg-burgundy transition-colors text-sm">Prenota <ArrowUpRight size={15} /></Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
